export const FLAG_VALUES = {
    SAFE: 'Safe',
    CAUTION: 'Caution',
    THREAT: 'Threat'
}

export const FlagColors = {
    [FLAG_VALUES.SAFE]: 'lime',
    [FLAG_VALUES.CAUTION]: 'yellow',
    [FLAG_VALUES.THREAT]: 'red'
}

export const noFlagPlaceholder = 'No Flag';